module.exports = __webpack_public_path__ + "static/media/home-24-icon.9e12b994.svg";